(function(){
  var money = function(c, fmt){
    var v = (c/100).toFixed(2).replace('.', ',');
    return (fmt || '{{amount_with_comma_separator}} €').replace(/\{\{\s*\w+\s*\}\}/, v);
  };

  /* Cuenta atrás hasta medianoche */
  function initCount(el){
    function tick(){
      var now = new Date(), end = new Date(now); end.setHours(24,0,0,0);
      var s = Math.max(0, Math.floor((end-now)/1000));
      var h = Math.floor(s/3600), m = Math.floor(s%3600/60), x = s%60;
      el.querySelector('[data-h]').textContent = String(h).padStart(2,'0');
      el.querySelector('[data-m]').textContent = String(m).padStart(2,'0');
      el.querySelector('[data-s]').textContent = String(x).padStart(2,'0');
    }
    tick(); setInterval(tick, 1000);
  }
  document.querySelectorAll('[data-mn-count]').forEach(initCount);

  /* Menú móvil */
  document.querySelectorAll('[data-mn-burger]').forEach(function(b){
    var d = document.querySelector(b.getAttribute('data-mn-burger'));
    b.addEventListener('click', function(){ d.classList.add('is-open'); });
    d && d.querySelector('[data-close]').addEventListener('click', function(){ d.classList.remove('is-open'); });
  });

  /* Producto */
  document.querySelectorAll('[data-mn-prod]').forEach(function(root){
    var data = JSON.parse(root.querySelector('[data-mn-json]').textContent);
    var fmt = data.money;
    var track = root.querySelector('.mn-gal__track');
    var slides = root.querySelectorAll('.mn-gal__slide');
    var thumbs = root.querySelectorAll('.mn-gal__thumb');
    var cur = 0;
    function go(i, smooth){
      if (!slides.length) return;
      cur = (i + slides.length) % slides.length;
      track.scrollTo({left: slides[cur].offsetLeft, behavior: smooth === false ? 'auto' : 'smooth'});
      setActive(cur);
    }
    function setActive(i){
      thumbs.forEach(function(t,k){ t.classList.toggle('is-active', k===i); });
      var t = thumbs[i]; if (t) t.parentNode.scrollTo({left: t.offsetLeft - 40, behavior:'smooth'});
    }
    thumbs.forEach(function(t,k){ t.addEventListener('click', function(){ go(k); }); });
    var pv = root.querySelector('.mn-gal__arrow--prev'), nx = root.querySelector('.mn-gal__arrow--next');
    pv && pv.addEventListener('click', function(){ go(cur-1); });
    nx && nx.addEventListener('click', function(){ go(cur+1); });
    var st; track && track.addEventListener('scroll', function(){
      clearTimeout(st); st = setTimeout(function(){
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== cur){ cur = i; setActive(i); }
      }, 80);
    });

    var variant = data.variants.find(function(v){ return v.id === data.selected; }) || data.variants[0];
    var idInput = root.querySelector('[name="mn-variant"]');
    var packs = root.querySelectorAll('.mn-pack');
    var stickySel = document.querySelector('[data-mn-sticky-select="'+data.section+'"]');

    function packQty(){ var a = root.querySelector('.mn-pack input:checked'); return a ? parseInt(a.value,10) : 1; }
    function render(){
      packs.forEach(function(p){
        var q = parseInt(p.dataset.qty,10), d = parseFloat(p.dataset.disc)||0;
        var now = Math.round(variant.price*q*(100-d)/100);
        var base = Math.max(variant.compare||0, variant.price) * q;
        p.querySelector('[data-now]').textContent = money(now, fmt);
        var s = p.querySelector('[data-was]');
        if (s){ s.textContent = base > now ? money(base, fmt) : ''; }
        var u = p.querySelector('[data-unit]');
        if (u && q > 1) u.textContent = money(Math.round(now/q), fmt) + ' / ud.';
        p.classList.toggle('is-active', p.querySelector('input').checked);
        if (p.querySelector('input').checked){
          document.querySelectorAll('[data-mn-sticky-now="'+data.section+'"]').forEach(function(e){ e.textContent = money(now, fmt); });
          document.querySelectorAll('[data-mn-sticky-was="'+data.section+'"]').forEach(function(e){ e.textContent = base > now ? money(base, fmt) : ''; });
          document.querySelectorAll('[data-mn-sticky-save="'+data.section+'"]').forEach(function(e){
            var pc = base > now ? Math.round((base-now)*100/base) : 0;
            e.style.display = pc ? '' : 'none'; e.textContent = (e.dataset.label||'AHORRA') + ' ' + pc + '%';
          });
        }
      });
      if (!packs.length){
        document.querySelectorAll('[data-mn-sticky-now="'+data.section+'"]').forEach(function(e){ e.textContent = money(variant.price, fmt); });
      }
      idInput.value = variant.id;
      root.querySelectorAll('[data-mn-atc]').forEach(function(b){
        b.disabled = !variant.available;
        b.textContent = variant.available ? b.dataset.label : b.dataset.soldout;
      });
      document.querySelectorAll('[data-mn-sticky-atc="'+data.section+'"]').forEach(function(b){
        b.textContent = variant.available ? b.dataset.label : b.dataset.soldout;
      });
    }
    packs.forEach(function(p){
      p.querySelector('input').addEventListener('change', function(){
        render(); if (stickySel) stickySel.value = this.value;
      });
    });
    stickySel && stickySel.addEventListener('change', function(){
      var inp = root.querySelector('.mn-pack input[value="'+this.value+'"]'); if (inp){ inp.checked = true; render(); }
    });
    root.querySelectorAll('.mn-swatch').forEach(function(b){
      b.addEventListener('click', function(){
        root.querySelectorAll('.mn-swatch').forEach(function(x){ x.classList.remove('is-active'); });
        b.classList.add('is-active');
        variant = data.variants.find(function(v){ return v.id == b.dataset.id; }) || variant;
        if (variant.media != null){
          var idx = Array.prototype.findIndex.call(slides, function(s){ return s.dataset.media == variant.media; });
          if (idx > -1) go(idx);
        }
        root.querySelectorAll('.mn-pack__img').forEach(function(im){ if (b.dataset.img){ im.removeAttribute('srcset'); im.src = b.dataset.img; } });
        document.querySelectorAll('[data-mn-sticky-img="'+data.section+'"]').forEach(function(im){ if (b.dataset.img) im.src = b.dataset.img; });
        render();
      });
    });
    render();

    function addToCart(btn){
      var items = [{ id: variant.id, quantity: packQty() }];
      var addon = root.querySelector('[data-mn-addon]:checked');
      if (addon) items.push({ id: parseInt(addon.value,10), quantity: 1 });
      btn.disabled = true;
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'},
        body: JSON.stringify({ items: items })
      }).then(function(r){ return r.json(); }).then(function(res){
        if (res && res.status && res.status !== 200){ alert(res.description || res.message); btn.disabled = false; return; }
        window.location.href = data.after === 'checkout' ? '/checkout' : (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart';
      }).catch(function(){ btn.disabled = false; });
    }
    root.querySelectorAll('[data-mn-atc]').forEach(function(b){ b.addEventListener('click', function(e){ e.preventDefault(); addToCart(b); }); });
    document.querySelectorAll('[data-mn-sticky-atc="'+data.section+'"]').forEach(function(b){
      b.addEventListener('click', function(e){ e.preventDefault(); addToCart(b); });
    });

    /* Barra fija */
    var sticky = document.querySelector('[data-mn-sticky="'+data.section+'"]');
    var mainBtn = root.querySelector('[data-mn-atc]');
    if (sticky && mainBtn && 'IntersectionObserver' in window){
      new IntersectionObserver(function(en){
        var e = en[0];
        sticky.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      }).observe(mainBtn);
    }
  });

  /* Comparador antes/después */
  document.querySelectorAll('.mn-ba input').forEach(function(r){
    var ba = r.closest('.mn-ba');
    r.addEventListener('input', function(){ ba.style.setProperty('--pos', r.value + '%'); });
  });

  /* Carrusel vida real */
  document.querySelectorAll('[data-mn-real]').forEach(function(sec){
    var tr = sec.querySelector('.mn-real__track'), items = tr.children, dots = sec.querySelector('.mn-dots');
    if (!dots) return;
    var per = function(){ return window.innerWidth < 900 ? 1 : 2; };
    function build(){
      dots.innerHTML = '';
      var n = Math.ceil(items.length / per());
      if (n < 2) return;
      for (var i=0;i<n;i++){ (function(i){
        var b = document.createElement('button'); b.type='button'; b.setAttribute('aria-label','Ir a '+(i+1));
        b.addEventListener('click', function(){ tr.scrollTo({left: items[i*per()].offsetLeft - tr.offsetLeft, behavior:'smooth'}); });
        dots.appendChild(b);
      })(i); }
      upd();
    }
    function upd(){
      var i = Math.round(tr.scrollLeft / (tr.scrollWidth / items.length) / per());
      Array.prototype.forEach.call(dots.children, function(d,k){ d.classList.toggle('is-active', k===i); });
    }
    tr.addEventListener('scroll', function(){ requestAnimationFrame(upd); });
    window.addEventListener('resize', build); build();
  });

  /* Reseñas: cargar más */
  document.querySelectorAll('[data-mn-more]').forEach(function(b){
    b.addEventListener('click', function(){
      var g = b.previousElementSibling, h = g.querySelectorAll('.mn-rev.is-hidden');
      for (var i=0;i<Math.min(6,h.length);i++) h[i].classList.remove('is-hidden');
      if (g.querySelectorAll('.mn-rev.is-hidden').length === 0) b.remove();
    });
  });

  /* Aparición al hacer scroll */
  if ('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(en){
      en.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, {threshold:.12});
    document.querySelectorAll('.mn-reveal').forEach(function(el){ io.observe(el); });
  } else { document.querySelectorAll('.mn-reveal').forEach(function(el){ el.classList.add('is-in'); }); }
})();
